var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dream)?_c('div',[_c('DreamForm',{attrs:{"dream":_vm.dream,"title":"Edit Dream","saveCallback":_vm.saveDream,"cancelCallback":_vm.cancel}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }